import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  connect () {
    this.updateButtonState(false) // Initialize button text
    this.hidePopup = this.element.dataset.hidePopup === 'true'
    // Set up modal button listeners
    this.setupModalListeners()
  }

  setupModalListeners () {
    const confirmBtn = document.getElementById('confirm-comment-popup')
    const cancelBtn = document.getElementById('cancel-comment-popup')

    if (confirmBtn && cancelBtn && !confirmBtn.dataset.listenerAttached) {
      confirmBtn.dataset.listenerAttached = 'true'
      confirmBtn.addEventListener('click', () => {
        const dontShow = document.getElementById('dont-show-again').checked

        if (dontShow) {
          fetch('/users/hide_comment_popup', {
            method: 'POST',
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
          })
        }

        document.getElementById('comment-popup-modal').classList.add('hidden')
        this.startCommentMode()
      })

      cancelBtn.addEventListener('click', () => {
        document.getElementById('comment-popup-modal').classList.add('hidden')
      })
    }
  }

  toggleMode (event) {
    event.preventDefault()
    event.stopPropagation()
    // Prevent multiple toggles from different buttons
    if (window.commentModeToggling) {
      return
    }
    window.commentModeToggling = true
    setTimeout(() => { window.commentModeToggling = false }, 100)
    if (!this.hidePopup) {
      document.getElementById('comment-popup-modal').classList.remove('hidden')
    } else {
      this.startCommentMode()
    }
  }

  startCommentMode () {
    // Change cursor to crosshair (which looks like a '+')
    document.body.style.cursor = 'crosshair'

    // Dispatch a browser event that the Vue component can listen for
    const customEvent = new CustomEvent('toggle-comment-mode', { bubbles: true })
    window.dispatchEvent(customEvent)
  }

  // This function might need rethinking or removal if state isn't tracked here
  updateButtonState (isActive) {
    if (this.hasButtonTarget) {
      // We don't reliably know the state here anymore
      // Let's just set initial text, Vue component will manage active state display
      // this.buttonTarget.classList.toggle('active', isActive)
      this.buttonTarget.textContent = 'Comment' // Always reset to Comment for now
    }
  }
}
